import {
  ApiResponse,
  DelivertyOptionsResponse,
  GuestStoreDeliveryOptionsResponseData,
  PudoSearchResponseData,
  ListDirectionsResponse,
  CheckDirectionListVersionResponse,
} from '../models/apiResponse';
import { IGenericInfoBlock } from '../models/generic-info-block/generic-info-block';
import {
  IDeliveryLimitationsRequest,
  IDeliveryLimitationsResponse,
  transformDeliveryLimitationsResponse,
} from '../models/parcelDimensions';
import { PudoSearch } from '../models/pudoSearchRequest';
import {
  DeliveryOptionsRequest,
  DeliveryRoute,
} from '../models/shipmentCountryInfo';
import { StoreDeliveryOptionsRequest } from '../models/storeDeliveryOptions';
import { apiRequests as requests } from './http-client';
import {
  FIVE_MINUTE_POST_CACHE_CONFIG,
  FORTY_FIVE_SECOND_POST_CACHE_CONFIG,
} from './cache-config';

const Guest = {
  guestDeliveryLimitations: (body: IDeliveryLimitationsRequest) =>
    requests
      .post<
        ApiResponse<IDeliveryLimitationsResponse>
      >(`/v1/guest/delivery-limitations`, body, FIVE_MINUTE_POST_CACHE_CONFIG)
      .then((response) => transformDeliveryLimitationsResponse(response.data)),

  guestDeliveryOptionsV2: (request: DeliveryOptionsRequest) =>
    requests
      .post<
        ApiResponse<DelivertyOptionsResponse>
      >('/v1/guest/delivery-options-v3', request, FORTY_FIVE_SECOND_POST_CACHE_CONFIG)
      .then((response) => ({
        data: response.data,
        messageBus: response.message_bus ?? [],
      })),

  guestDeliveryHints: (
    departureCountryCode: string,
    destinationCountryCode: string
  ) =>
    requests
      .post<ApiResponse<IGenericInfoBlock>>(
        '/v1/guest/delivery-hints',
        {
          departure: departureCountryCode,
          destination: destinationCountryCode,
        },
        FIVE_MINUTE_POST_CACHE_CONFIG
      )
      .then((response) => response.data),

  guestStoreDeliveryOptions: (deliveryOptions: StoreDeliveryOptionsRequest) =>
    requests
      .post<
        ApiResponse<GuestStoreDeliveryOptionsResponseData>
      >('/v1/guest/store-delivery-options', deliveryOptions)
      .then((response) => ({
        shipment: response.data?.shipment,
        tokens: response.data?.tokens,
      })),

  guestSearchPudo: (carrier: string, pudoSearch: PudoSearch) =>
    requests
      .post<PudoSearchResponseData>(
        `/v1/guest/search/pudo/${carrier}`,
        pudoSearch,
        FORTY_FIVE_SECOND_POST_CACHE_CONFIG
      )
      .then((response) => response),

  listDirections: () =>
    requests
      .get<ApiResponse<ListDirectionsResponse>>('/v1/guest/directions/list')
      .then((response) => response.data),

  checkDirectionsListVersion: (version: string) =>
    requests
      .post<
        ApiResponse<CheckDirectionListVersionResponse>
      >(`/v1/guest/directions/check`, { version })
      .then((response) => response.data),

  registerRouteExpectation: (request: DeliveryRoute) =>
    requests
      .post<ApiResponse>(`/v1/guest/expect-route`, request)
      .then((response) => response.data),
};

export default Guest;
